import React, { useState } from "react";
import { apiRequest } from "../api";

const DeployEventTemplateModal = ({ eventTemplate, onClose, onDeploy }) => {
    const [deploying, setDeploying] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL || "https://localhost:8000";
    const token = localStorage.getItem("token");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDeploying(true);
        setError(null);
        setSuccessMessage(null);
        try {
            const result = await apiRequest(
                `${apiUrl}/event-templates/${eventTemplate.id}/deploy`,
                "POST",
                {},
                token
            );
            
            // Show deployment results in modal
            let message = result.message;
            if (result.skipped_tours && result.skipped_tours.length > 0) {
                message += "\n\nSkipped tours:\n" + result.skipped_tours.map(s => s.reason).join("\n");
            }
            setSuccessMessage(message);
            
            // Auto-close after 3 seconds
            setTimeout(() => {
                onDeploy();
                onClose();
            }, 3000);
        } catch (err) {
            setError("Failed to deploy event template.");
        } finally {
            setDeploying(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "500px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <h4>Deploy Event Template</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <p>
                            This will create events for <b>all tours</b> linked to the parent tour template.<br />
                            Tours that already have events from this template will be skipped.<br />
                            Are you sure you want to proceed?
                        </p>
                    </div>
                    {error && <div className="error">{error}</div>}
                    {successMessage && (
                        <div
                            style={{
                                marginTop: "10px",
                                padding: "10px",
                                backgroundColor: "#d4edda",
                                border: "1px solid #c3e6cb",
                                borderRadius: "4px",
                                color: "#155724",
                                whiteSpace: "pre-line"
                            }}
                        >
                            {successMessage}
                        </div>
                    )}
                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={deploying}
                        >
                            {deploying ? "Deploying..." : "Deploy"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={deploying}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeployEventTemplateModal; 